export function getListPreferencesId(preferencesKey: string, url: string): number {
  const listUrl = url.split(/[?#]/)[0].replace(/[\w\d]{8}(-[\w\d]{4}){3}-[\w\d]{12}/, '');
  let hash = 0;
  for (const char of `${preferencesKey}${listUrl}`) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return hash;
}
